import { MotionActiveLineStyle } from "./ActiveLineStyles";

export const ActiveLine = () => {
  return <MotionActiveLineStyle layoutId="activeItem" />;
};
